
import { Vue, Component, Prop } from 'vue-property-decorator';
import InvoiceHeader from '@/components/invoice/InvoiceForm/InvoiceFormHeader.vue';
import GET_INVOICE from '@/apollo/invoice/GetInvoice.gql';
import { User } from '@/generated/graphql';
import moment from 'moment';
import TickIcon from '@/components/icons/TickIcon.vue';
import Cross from '@/components/icons/Cross.vue';
import storage from '@/services/storage';

import NavGrayArrow from '@/components/icons//NavGrayArrow.vue';

import { NOTIFICATION } from '@/entities/Events';
import Message from '@/data/notificationsMessages';
import UPDATE_INVOICE from '@/apollo/invoice/UpdateInvoice.gql';
import UiButton from '@/components/button/ui-button.vue';
import CancelInvoiceModal from '@/components/invoice/modal/CancelInvoiceDialog.vue';

@Component({
	components: {
		InvoiceHeader,
		TickIcon,
		Cross,
		UiButton,
		CancelInvoiceModal,
		NavGrayArrow,
	},
})
export default class SubmitForm extends Vue {
	@Prop({ type: Object, required: true }) readonly currentUser!: User;

	invoiceInfo: any = {};
	isOpen = false;
	totalHours = '';
	totalAmount = 0;
	invoiceData: any = [];

		parseTimeToMinutes(timeString: string) {
		let totalMinutes = 0;
		const parts = timeString.match(/(\d+)(h|m)/g);

		if (parts) {
			for (const part of parts) {
				const value = parseInt(part);
				if (part.includes('h')) {
					totalMinutes += value * 60;
				} else if (part.includes('m')) {
					totalMinutes += value;
				}
			}
		}

		return totalMinutes;
	}

	created() {
		this.$apollo
			.query({
				query: GET_INVOICE,
				variables: {
					id: this.$route.params.id,
				},
				fetchPolicy: 'network-only',
			})
			.then(async ({ data }) => {
				const invoice = data.invoice_by_pk;
				let file = null;
				if (invoice.file) {
					const filename = invoice.file.key.split('/')[1];
					file = await this.getFile(filename);
				}
			
        const tasks = [];
        const getActivities = invoice.project_activity_times.map((activity) => {
            let currentTask = tasks.find((task) => task.id === activity.project_activity.id);
            if (currentTask === undefined) {
              tasks.push(activity.project_activity);
            }
            return tasks;
        });
		
				this.invoiceData = tasks
					.map((activity) => {
						const approvedTimes =
									activity.project_activity_times
						return {
							date: moment(activity.created_at).format(
								'MMM D, YYYY'
							),
							task: activity.title,
							rate: `$${invoice.rate}`,
							hours: this.formatTotalHours(approvedTimes),
							totalAmount: `$${this.calculateAmountForActivity(
								approvedTimes,
								invoice.rate
							).toFixed(2)}`,
						};
					});
					const totalMinutes = this.invoiceData.reduce((total, item) => {
			return total + this.parseTimeToMinutes(item.hours);
		}, 0);

		const hours = Math.floor(totalMinutes / 60);
		const minutes = totalMinutes % 60;
		this.totalHours = `${hours}h ${minutes}m`;

		const totalAmountDue = this.invoiceData.reduce((total, item) => {
			const amount = parseFloat(item.totalAmount.replace('$', ''));
			return total + amount
		}, 0);
		 this.totalAmount = parseFloat(totalAmountDue.toFixed(2));
					this.invoiceInfo = {
					'Company Name':
						invoice?.project?.company?.business_name || 'N/A',
					Project: invoice?.project?.client_name,
					'Reference Number': invoice.invoice_ref,
					'External Invoice Link': file ?? invoice.external_link,
					fileName: file
						? invoice.file.key.split('/')[1]
						: invoice.external_link,
					fileTypeMessage: file
						? 'File name'
						: 'External Invoice Link',
					'Total hours': `${this.totalHours}`,
					'Total Amount before taxes': `CAD $${this.totalAmount}`,
					Status: invoice.status,
					file: file,
					'User Name': this.getFullName(invoice.user),
					'Submission Date': moment(
						invoice.invoice_submission_date
					).format('MMM D, YYYY'),
				};
				if (this.currentUser.role === 'ADMIN' && !invoice.is_opened) {
					this.$apollo
						.mutate({
							mutation: UPDATE_INVOICE,
							variables: {
								set: { is_opened: true },
								id: this.$route.params.id,
							},
						})
						.catch((err) => {});
				}
			})
			.catch((err) => {
				console.log('🚀 ~ SubmitForm ~ created ~ err:', err);
			});
	}
	toggle() {
		this.isOpen = true;
	}
	async getFile(filename: string) {
		return await storage
			.get(filename)
			.then((result: any) => result)
			.catch((err: any) => {
				throw err;
			});
	}
	calculateFormattedTotalHours(activities) {
		const totalSeconds = activities.reduce((sum, activity) => {
			const approvedSeconds = activity.project_activity_times
				.filter((time) => time.status === 'APPROVED')
				.reduce((innerSum, time) => innerSum + time.time, 0);
			return sum + approvedSeconds;
		}, 0);
		return this.formatTotalHoursFromSeconds(totalSeconds);
	}
	status(value) {
		switch (value) {
			case 'PENDING':
				return 'Pending Approval';
			case 'APPROVED':
				return 'Invoice Approved';
			case 'REJECTED':
				return 'Invoice Rejected';
			case 'PAID':
				return 'Paid';
			case 'PAYMENT SEND':
				return 'Payment Sent';
			case 'CANCEL':
				return 'Cancelled';

			default:
				break;
		}
		return `${value?.toLowerCase()?.replace(/\s+/g, '-')}`;
	}

	parseHours(hourString) {
		return parseFloat(hourString);
	}

calculateTotalHoursFinal(approvedTimes) {
		return approvedTimes.reduce((sum, time) => sum + time.time, 0) / 3600;
	}

	// 	calculateTotalHours(items) {
	// 	return (
	// 		items.reduce(
	// 			(total, item) => total + this.parseHours(item.hours),
	// 			0
	// 		) + 'h'
	// 	);
	// }
calculateTotalAmountFinal(hours, budget) {
    if(budget !== 'n/a') {
      return hours * budget;
    }
    else{
      return 0;
    }
  }

formatedcalculateTotalHours(approvedTimes) {
    const totalSeconds = approvedTimes.reduce(
      (sum, time) => sum + time.time,
      0
    );
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    return `${hours}h ${minutes}m`;
  }

	calculateTotalAmount(activities) {
		const totalAmount = activities.reduce((sum, activity) => {
			const approvedSeconds = activity.project_activity_times
				.filter((time) => time.status === 'APPROVED')
				.reduce((innerSum, time) => innerSum + time.time, 0);
			const hours = approvedSeconds / 3600;
			return sum + hours * activity.budget;
		}, 0);
		return `$${totalAmount.toFixed(2)}`;
	}
	formatTotalHoursFromSeconds(totalSeconds) {
		const hours = Math.floor(totalSeconds / 3600);
		const minutes = Math.floor((totalSeconds % 3600) / 60);
		return `${hours}h ${minutes}m`;
	}
	calculateAmountForActivity(approvedTimes, budget) {
		const totalSeconds = approvedTimes.reduce(
			(sum, time) => sum + time.time,
			0
		);
		const hours = totalSeconds / 3600;
		return hours * budget;
	}
	formatTotalHours(approvedTimes) {
		const totalSeconds = approvedTimes.reduce(
			(sum, time) => sum + time.time,
			0
		);
		return this.formatTotalHoursFromSeconds(totalSeconds);
	}
	getFullName(user): string {
		const givenName = user?.given_name ?? '';
		const familyName = user?.family_name ?? '';
		return `${givenName} ${familyName}`;
	}
	handleBack() {
		this.$router.push('/invoice/');
	}
	handleClose() {
		this.$router.push('/invoice/');
	}
	async handleDownload() {
		if (this.invoiceInfo.file) {
			window.open(this.invoiceInfo.file, '_self');
			return;
		}
		window.print();
	}
	sendInvoiceByEmail() {
		const subject = encodeURIComponent(
			`Invoice for [${this.invoiceInfo['Reference Number']}] - Action Required`
		);
		const body = encodeURIComponent(
			`Please find attached the invoice for your reference regarding subject cited above for your attention:  ${window.location.origin}/invoice/${this.$route.params.id}`
		);
		const mailto = `mailto:?subject=${subject}&body=${body}`;
		window.open(mailto, '_blank');
		window.location.href = mailto;
	}
	async handleCopy() {
		await navigator.clipboard.writeText(
			`${window.location.origin}/invoice/${this.$route.params.id}`
		);
		this.$eventBus.emit(
			NOTIFICATION,
			Message.successMessage(`URL copied to clipboard!`)
		);
	}
	handleEdit() {
		this.$router.push(`/invoice/edit/${this.$route.params.id}`);
	}
	async cancelSelected() {
		await this.$apollo.mutate({
			mutation: UPDATE_INVOICE,
			variables: {
				set: { status: 'CANCEL' },
				id: this.$route.params.id,
			},
		});
		this.isOpen = false;
		this.invoiceInfo.Status = 'CANCEL';
		this.$eventBus.emit(
			NOTIFICATION,
			Message.successMessage(`Invoice Cancelled`)
		);
	}
	async approveSelected() {
		await this.$apollo.mutate({
			mutation: UPDATE_INVOICE,
			variables: {
				set: { status: 'APPROVED' },
				id: this.$route.params.id,
			},
		});
		this.invoiceInfo.Status = 'APPROVED';
		this.$eventBus.emit(
			NOTIFICATION,
			Message.successMessage(`Status Successfully Updated`)
		);
	}

	async rejectSelected() {
		await this.$apollo.mutate({
			mutation: UPDATE_INVOICE,
			variables: {
				set: { status: 'REJECTED' },
				id: this.$route.params.id,
			},
		});
		this.invoiceInfo.Status = 'REJECTED';
		this.$eventBus.emit(
			NOTIFICATION,
			Message.successMessage(`Status Successfully Updated`)
		);
	}
}
